import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const NotFound = () => {
  return (
    <>
      <Helmet>
        <title>Sope Adelaja | Page Not Found</title>
        <meta name="description" content="The page you are looking for could not be found." />
      </Helmet>

      <div className="bg-[#252525] min-h-screen w-full flex items-center justify-center px-5">
        <div className="text-center max-w-lg">
          <h1 className="font-navbar text-7xl md:text-9xl text-[#b7a78b] tracking-[0.1em] mb-4">
            404
          </h1>
          <h2 className="uppercase text-[#e7ddd3] text-xl md:text-2xl font-semibold tracking-[.15em] mb-4">
            Page Not Found
          </h2>
          <p className="text-[#cdc2ad] text-[15px] leading-relaxed mb-10">
            The page you are looking for doesn’t exist or may have been moved.
          </p>
          <Link
            to="/"
            className="inline-block px-7 py-3.5 border border-[#b7a78b] text-[#e4e4e3] text-[12px] uppercase
              tracking-[0.2em] font-semibold transition-all duration-300 hover:bg-[#b7a78b] hover:text-black"
          >
            Back To Home
          </Link>
        </div>
      </div>
    </>
  );
};

export default NotFound;
